'use strict';
import {Injectable, Inject} from 'ng-metadata/core';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {BriefResultService} from '../briefResult/briefResult.service';
import {TemplateUtil} from '../../nddUtils/templateUtil.service';
import {JwtUtilService} from '../../security/jwtUtil.service';
import {FavoritesService} from '../../favorites/favorites.service';
import {MediaQueries} from '../../infra/mediaQueries.service';
import {isBrowserIE} from '../../infra/browserSniffer';
import {FullViewModuleLoaderService} from "./fullViewModuleLoader.service";


@Injectable()
export class FullViewDialogService {

    constructor(@Inject('$mdDialog') private $mdDialog: angular.material.IDialogService,
                @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$mdToast') private $mdToast: ng.material.IToastService,
                private briefResultService: BriefResultService,
                private templateUtil: TemplateUtil,
                private jwtUtilService: JwtUtilService,
                private favoritesService: FavoritesService,
                private mediaQueries: MediaQueries,
                private fullViewModuleLoaderService: FullViewModuleLoaderService) {
    }


    public openFullViewDialog(item, event, originator) { //serviceId is the id of the service we want to focus on when we open the full view dialog
        let serviceId;


        let target;
        if (event) {
            target = event.target;
            if (target && target.hasAttribute('prm-brief-internal-button-marker') ||
                target.classList.contains('prm-brief-internal-button-marker')) {
                return false;
            }

            serviceId = event.detail ? event.detail.index : event.index;
        }


        this.$mdToast.hide();
        let loadFullViewAdditionalServices = {val: isBrowserIE() ? false : true};
        let dialogOpened = {val: false};
        this.fullViewModuleLoaderService.loadFullViewModule().then(()=> { //we need to wait for full view module to be loaded because we lazily load the chunk
            //change the url  to deep link url but don't trigger the ui router
            let previousUrl = this.$location.url(); //save the url so you can restore it when dialog window is closed
            this.$location.url(this.templateUtil.getDeepLinkPath(item));

            this.favoritesService.needToChangeUrl = false;

            let dialog = this.$mdDialog;
            dialog.show({
                onComplete: ()=> {

                    if (loadFullViewAdditionalServices.val) {
                        dialogOpened.val = true;
                    }
                    else {
                        this.$timeout(() => dialogOpened.val = true, 0);
                        this.$timeout(() => loadFullViewAdditionalServices.val = true, 1000);
                    }
                },
                onRemoving: ()=> {
                    backListener();
                    this.handleDialogHide(previousUrl, target)
                },
                // template: templateString,
                templateUrl: 'components/search/fullView/full-view-dialog-template.html',
                locals: {
                    focusId: serviceId,
                    item: item,
                    $location: this.$location,
                    perviousUrl: previousUrl,
                    $state: this.$state,
                    favoritesService: this.favoritesService,
                    jwtUtilService: this.jwtUtilService,
                    mediaQueries: this.mediaQueries,
                    isfavorites: this.isfavorites,
                    loadFullViewAdditionalServices: loadFullViewAdditionalServices,
                    dialogOpened: dialogOpened,
                    originator: originator,
                    briefResultService: this.briefResultService
                },
                bindToController: true,
                clickOutsideToClose: true,
                fullscreen: true,
                escapeToClose: true,
                focusOnOpen: false, // we will handle focus ourselves since it doesnt seem to work in md
                controller: function () {
                    let vm = this;
                    vm.handleHideDetails = handleHideDetails;
                    vm.currentStateResults = currentStateResults;
                    vm.currentResultIndex = currentResultIndex;
                    vm.isFirstRecord = isFirstRecord;
                    vm.isLastRecordByState = isLastRecordByState;
                    function handleHideDetails() {
                        dialog.hide();
                    }

                    function currentStateResults() {
                        return [this.item];
                    }

                    function currentResultIndex() {
                        return 0;
                    }

                    function isFirstRecord() {
                        return true;
                    }

                    function isLastRecordByState() {
                        return true;
                    }

                },
                controllerAs: '$ctrl'
            });


            let listener;
            let backListener;
            listener = this.$rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
                event.preventDefault();
                listener();
                listener = this.$rootScope.$on('$locationChangeStart', (event)=> {
                    event.preventDefault();
                    listener(); //this unregisters the event listener so we can revert to previous url once dialog is closed
                });
                //This code is for handling the back browser button
                //We want the transition between full to search
                // to close the dialog

                backListener = this.$rootScope.$watch(() => {
                    return this.$location.path()
                }, (newLocation, oldLocation)=> {
                    if (oldLocation === '/fulldisplay' && newLocation != '/fulldisplay') {
                        this.$mdDialog.cancel();
                        backListener();
                    }
                });
            });


            /*$mdDialog.closeDialog = function() {
             $mdDialog.hide();
             }*/
        });

        return true;
    }

    private handleDialogHide(perviousUrl, element) {
        //if dialog is closed because we want to get frbr don't restore previous url since we are adding facet to it
        if (this.briefResultService.isInGetFrbrEvent) {
            return;
        }
        this.$location.url(perviousUrl);
        //in case we are in favorites and need to change the url (record that was removed with unique label). in users only
        if ((this.$state.current.name == STATE_NAMES.FAVORITES) && (this.jwtUtilService.isSignedIn()) && this.favoritesService.needToChangeUrl) {
            this.favoritesService.needToChangeUrl = false;
            this.favoritesService.getItemsFromServer();
        }
        if (element) {
            element.setAttribute('tabindex', '-1');
            element.focus();
            element.setAttribute('tabindex', '0');

        }
    }
}


//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/fullViewDialog.service.ts